import log from 'salvo-lite/log'

class ModifyComponent {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._options = JSON.parse(this._elem.dataset.modifyComponent)
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiating')

        if (this._options.length) {
            for (let data of this._options) {
                this.modifyComponent(data)
            }
        } else {
            this.modifyComponent(this._options)
        }

        log.debug(this.constructor.name, 'Initiated')
    }

    modifyComponent (data) {
        let args = [].concat(data.arguments || '')
        this._elem.addEventListener(data.on, e => {
            this._theme.getComponentsById(data.componentId)[data.method](...args)
        })
    }
}

export default ModifyComponent



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ModifyComponent.js